import React from 'react';
import { Tooltip } from 'antd';
import { AimOutlined, EyeOutlined } from '@ant-design/icons';
import { useGetCountries } from 'api/countries/use-get-countries';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses';
import { useCopyToClipboard } from 'shared/hooks/use-copy-to-clipboard';
import { findCountriesById } from 'shared/utils/countries';
import { findWarehouseById } from 'shared/utils/warehouses/find-warehouse-by-id';
import type { ITripTaskItemAddressProps } from 'components/trips/trip-tasks/components/trip-task-item-address/types';
import styles from './trip-task-item-address.module.scss';

export const TripTaskItemAddress: React.FC<ITripTaskItemAddressProps> = ({ address, warehouseId }) => {
  const { data: countries } = useGetCountries();
  const { data: warehouses } = useGetManyWarehouses();

  const copy = useCopyToClipboard();
  const country = findCountriesById(address?.countryId, countries);
  const warehouse = findWarehouseById(warehouseId, warehouses);

  const coordinates = address?.lat && address?.lng ? `${address?.lat},${address?.lng}` : undefined;
  const googleLink = coordinates
    ? `https://www.google.com/maps?q=&layer=c&cbll=${address?.lat},${address?.lng}`
    : undefined;

  const hasAddress = Boolean(address?.address);

  const copyCoordinates = () => {
    if (coordinates) {
      copy(coordinates);
    }
  };

  const renderAddress = () => {
    if (!address) return null;

    if (!hasAddress) {
      return (
        <span>
          {address.lat},{address?.lng}
        </span>
      );
    }

    return (
      <span>
        <strong>{country?.code}</strong>, {address.postCode} {address.city}, {address.address}
      </span>
    );
  };

  const renderWarehouse = () => {
    if (!warehouse) return null;

    return (
      <div className={styles.address}>
        WH: <strong>{warehouse?.name}</strong>
      </div>
    );
  };

  if (address) {
    return (
      <>
        <div className={styles.address}>
          {googleLink && (
            <a href={googleLink} target='_blank' rel='noopener noreferrer'>
              <EyeOutlined />
            </a>
          )}
          <Tooltip title={coordinates}>
            <AimOutlined onClick={copyCoordinates} />
          </Tooltip>
          {renderAddress()}
        </div>
        <div className={styles.mt4}>{renderWarehouse()}</div>
      </>
    );
  }

  return <>{renderWarehouse()}</>;
};
